import { TicketRepository } from '../repositories/TicketRepository'

export function ListIndicatorsMetricsTmaCase(
  ticketRepository: TicketRepository
) {
  return async function ({
    areaId,
    data
  }: {
    areaId: string
    data: {
      month: number
      year: number
    }
  }) {
    return await ticketRepository.listIndicatorsMetricsTma({ areaId, data })
  }
}
